import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BaseSubsectionAdapter } from 'components/Assessments/adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { FuaFormData } from 'components/Assessments/FuaAssessment/types/FuaFormData'
import { MedicalBackgroundQuestionnaireItem } from 'components/Assessments/FuaAssessment/sections/MedicalBackground/questionnaire'
import { CareCoordinationFormField } from './formField'

/**
 * Care coordination subsection adapter
 * Handles care coordination fields (5 fields)
 */
export class CareCoordinationAdapter extends BaseSubsectionAdapter<FuaFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<FuaFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // Direct field extractions for all care coordination fields
    const previousAppointments = getAnswerValuesFromItems(
      flatAnswersArray,
      MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_PREVIOUS_APPOINTMENTS
    )?.at(0)

    const futureAppointments = getAnswerValuesFromItems(
      flatAnswersArray,
      MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_FUTURE_APPOINTMENTS
    )?.at(0)

    const careTeamCoordination = getAnswerValuesFromItems(
      flatAnswersArray,
      MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_CARE_TEAM_COORDINATION
    )?.at(0)

    const ordersForTreatment = getAnswerValuesFromItems(
      flatAnswersArray,
      MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_ORDERS_FOR_TREATMENT
    )?.at(0)

    const dateOfVerbalCommunication = getAnswerValuesFromItems(
      flatAnswersArray,
      MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_DATE_OF_VERBAL_COMMUNICATION
    )?.at(0)

    return {
      [CareCoordinationFormField.CARE_COORDINATION_PREVIOUS_APPOINTMENTS]: previousAppointments,
      [CareCoordinationFormField.CARE_COORDINATION_FUTURE_APPOINTMENTS]: futureAppointments,
      [CareCoordinationFormField.CARE_COORDINATION_CARE_TEAM_COORDINATION]: careTeamCoordination,
      [CareCoordinationFormField.CARE_COORDINATION_ORDERS_FOR_TREATMENT]: ordersForTreatment,
      [CareCoordinationFormField.CARE_COORDINATION_DATE_OF_VERBAL_COMMUNICATION]:
        dateOfVerbalCommunication
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    return [
      {
        linkId:
          MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_PREVIOUS_APPOINTMENTS,
        value: this.getFormDataField(
          CareCoordinationFormField.CARE_COORDINATION_PREVIOUS_APPOINTMENTS
        )
      },
      {
        linkId:
          MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_FUTURE_APPOINTMENTS,
        value: this.getFormDataField(
          CareCoordinationFormField.CARE_COORDINATION_FUTURE_APPOINTMENTS
        )
      },
      {
        linkId:
          MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_CARE_TEAM_COORDINATION,
        value: this.getFormDataField(
          CareCoordinationFormField.CARE_COORDINATION_CARE_TEAM_COORDINATION
        )
      },
      {
        linkId:
          MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_ORDERS_FOR_TREATMENT,
        value: this.getFormDataField(
          CareCoordinationFormField.CARE_COORDINATION_ORDERS_FOR_TREATMENT
        )
      },
      {
        linkId:
          MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_DATE_OF_VERBAL_COMMUNICATION,
        value: this.getFormDataField(
          CareCoordinationFormField.CARE_COORDINATION_DATE_OF_VERBAL_COMMUNICATION
        )
      }
    ]
  }
}
